var _defs, _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSymbolpack3Solid12({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}"))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 8,
    cy: 8,
    r: 7
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.83,3.91H8A8.24,8.24,0,0,1,9.38,4,1.94,1.94,0,0,1,10.8,5a1.78,1.78,0,0,1,.24.92,1.92,1.92,0,0,1-.29,1,2,2,0,0,1-.81.69,2.06,2.06,0,0,1,1.1.71,1.91,1.91,0,0,1,.39,1.19,2.25,2.25,0,0,1-.25,1,2.19,2.19,0,0,1-.68.82,2.35,2.35,0,0,1-1.07.37c-.26,0-.9,0-1.92,0H4.83ZM6.42,5.22V7h1c.62,0,1,0,1.15,0a1,1,0,0,0,.64-.28.81.81,0,0,0,.24-.61.84.84,0,0,0-.21-.6.89.89,0,0,0-.59-.27c-.16,0-.61,0-1.36,0Zm0,3.13v2.11H7.9A7.51,7.51,0,0,0,9,10.41a1,1,0,0,0,.57-.32,1,1,0,0,0,.23-.67,1,1,0,0,0-.67-1,5.74,5.74,0,0,0-1.41-.11Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSymbolpack3Solid12);
export default __webpack_public_path__ + "static/media/Symbolpack_3_solid_12.546f8676be0e792cd15357779ba81b9c.svg";
export { ForwardRef as ReactComponent };